import React from "react";

import ProfileList from "../../components/profileList/ProfileList";

const ProfileSelection = () => {
  return <ProfileList isFromProfileLogin={true} />;
};

export default ProfileSelection;
